import React from 'react';
import '../../App.css'

const Contact = () => {
    return (
        <div className='App'>
            <h1>This is Contact</h1>
            <h3>Md Asif Hossain</h3>
             <h3>Email : asif.hossain2k20@gmail.com</h3>
        </div>
    );
};

export default Contact;